export default __webpack_public_path__ + "static/6-3de4936ee8fd3befd17e8d72933cae43.webp";